import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Appraisal, ApprovalList } from 'src/app/shared/models/appraisal';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { Context } from 'src/app/shared/models/context';
import { Router } from '@angular/router';

@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.scss']
})
export class ApprovalComponent implements OnInit {
  @Input() context: Context;
  public approvals: ApprovalList[] = [];
  public appraisals: Appraisal[] = [];
  public activeAppraisalId: number;
  public appraisalId: number;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;

  constructor(
    private appraisalService: ApparaisalService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.appraisalService.getAppraisals().subscribe((appraisals: Appraisal[]) => {
      this.appraisals = appraisals;
      this.activeAppraisalId = this.appraisals.find(appraisal => appraisal.active)?.id;
      this.getApprovals();
    });
  }

  public getTruncatedName(name: string, maxLength: number): string {
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  }

  private getApprovals(clear: boolean = true) {
    if (this.activeAppraisalId) {
      if (clear) {
        this.isLoading = true;
        this.approvals = [];
      }
      this.appraisalService.getApprovalList(this.activeAppraisalId).subscribe({
        next: (approvals: ApprovalList[]) => {
          this.approvals = approvals.sort((a, b) => {
            return (b.status === 'APPRAISEE_SUBMITTED' ? 1 : 0) - (a.status === 'APPRAISEE_SUBMITTED' ? 1 : 0);
          });
          // this.approvals = approvals.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public onAppraisalChange() {
    this.getApprovals();
  }

  // public upsertApprovals(approval?: ApprovalList) {
  //   if (!this.privilege.canEdit) return;
  //   const modalRef = this.modalService.open(this.router.navigate(['/appraisal/manage-approval'],{queryParams:{aplId:approval?.appraisalDto?.id, aprId:approval?.appraiseeId, inactive:approval?.appraisalDto.active}}));
  //   modalRef.componentInstance.approval = approval;
  //   modalRef.componentInstance.appraisals = this.appraisals;
  //   modalRef.componentInstance.context = this.context;
  //   modalRef.result.then((response: ApprovalList) => {
  //     if (response) {
  //       this.getApprovals(false);
  //     }
  //   })
  // }

  public upsertApprovals(approval?: ApprovalList) {
    if (!this.privilege.canEdit) return;
    this.router.navigate(['/appraisal/manage-approval'], {
      queryParams: { aplId: approval?.appraisalId, aprId: approval?.appraiseeId, status: approval?.status, },
      state: {
        approval: approval,
        appraisals: this.appraisals,
        context: this.context,
      },
    });
  }

  


}

